module.exports = __webpack_public_path__ + "static/media/legalmind.5d48f9a7.jpg";